export const env = {
  matomoUrlBase: 'https://analytics.tools.citopia.fr/',
  matomoSiteId: 100,
  baseSurveyUrl: 'https://sondage.prod.tools.citopia.fr/survey',
}
